export default __webpack_public_path__ + "static/media/snowmountain.ae50830b.jpg";